import { repeatWhen, takeUntil } from 'rxjs/operators';
import { fromEvent, timer } from 'rxjs';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { TUI_ANIMATION_OPTIONS, TUI_NOTIFICATION_OPTIONS, TuiNotificationDefaultOptions } from '@taiga-ui/core/tokens';
import { TuiAlertOptions } from '@taiga-ui/core/interfaces';
import { TuiDestroyService, TuiDialog, tuiIsNumber } from '@taiga-ui/cdk';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Self,
} from '@angular/core';
import { AnimationOptions } from '@angular/animations';

@Component({
  selector: 'iss-toast',
  templateUrl: './toast.template.html',
  styleUrls: [ './toast.style.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ TuiDestroyService ],
})
export class ToastComponent<O, I> implements OnInit {
  private readonly autoClose =
    typeof this.item.autoClose === 'function'
      ? this.item.autoClose(this.item.status)
      : this.item.autoClose;

  constructor(
    @Inject(ElementRef) private readonly el: ElementRef<HTMLElement>,
    @Self() @Inject(TuiDestroyService) private readonly destroy$: TuiDestroyService,
    @Inject(TUI_NOTIFICATION_OPTIONS)
    private readonly options: TuiNotificationDefaultOptions,
    @Inject(TUI_ANIMATION_OPTIONS) readonly animation: AnimationOptions,
    @Inject(POLYMORPHEUS_CONTEXT) readonly item: TuiDialog<TuiAlertOptions<I>, O>,
  ) {}

  ngOnInit(): void {
    this.initAutoClose();
  }

  closeNotification(): void {
    this.item.$implicit.complete();
  }

  private initAutoClose(): void {
    if (!this.autoClose) {
      return;
    }

    timer(
      tuiIsNumber(this.autoClose)
        ? this.autoClose
        : this.options.defaultAutoCloseTime,
    )
      .pipe(
        takeUntil(fromEvent(this.el.nativeElement, 'mouseenter')),
        /**
                 * TODO: replace to
                 * repeat({
                 *    delay: () => fromEvent(this.el.nativeElement, 'mouseleave'),
                 * })
                 *
                 * in RxJS 7
                 */
        repeatWhen(() => fromEvent(this.el.nativeElement, 'mouseleave')),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.closeNotification());
  }
}
